(() => {
  if (window.tshStoriesBound) return;
  window.tshStoriesBound = true;
  const init = root => root.querySelectorAll('[data-story-video]').forEach(card => {
    if (card.dataset.bound) return;
    card.dataset.bound = 'true';
    const video = card.querySelector('video');
    const button = card.querySelector('.tsh-story-play');
    const status = card.querySelector('.tsh-story-status');
    video.controls = false;
    button.hidden = false;
    button.addEventListener('click', async () => {
      document.querySelectorAll('[data-story-video] video').forEach(other => {
        if (other !== video) other.pause();
      });
      if (!video.src) video.src = video.dataset.src;
      video.controls = true;
      card.classList.add('has-started');
      try {
        await video.play();
        button.hidden = true;
        video.focus({ preventScroll: true });
        status.textContent = '';
      } catch {
        status.textContent = status.dataset.errorText;
        button.hidden = false;
        card.classList.remove('has-started');
      }
    });
    video.addEventListener('play', () => {
      card.classList.add('has-started');
      document.querySelectorAll('[data-story-video] video').forEach(other => {
        if (other !== video) other.pause();
      });
      button.hidden = true;
    });
    video.addEventListener('error', () => {
      status.textContent = status.dataset.errorText;
      button.hidden = false;
      card.classList.remove('has-started');
    });
    const observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) video.pause();
    }, { threshold: .1 });
    observer.observe(card);
    const onVisibility = () => { if (document.hidden) video.pause(); };
    const onUnload = event => {
      if (!event.target.contains(card)) return;
      video.pause();
      observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('visibilitychange', onVisibility);
    document.addEventListener('shopify:section:unload', onUnload);
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
